export const TRANSFERMATE_COUNTRY = {
  INDIA: 'IN',
  CHINA: 'CN',
} as const;

/** Country options shared with Resident Portal TransferMate. */
export const TRANSFERMATE_COUNTRY_CODE = [
  { name: 'Afghanistan', value: 'AF' },
  { name: 'Aland Islands', value: 'AX' },
  { name: 'Albania', value: 'AL' },
  { name: 'Algeria', value: 'DZ' },
  { name: 'American Samoa', value: 'AS' },
  { name: 'Andorra', value: 'AD' },
  { name: 'Angola', value: 'AO' },
  { name: 'Anguilla', value: 'AI' },
  { name: 'Antigua and Barbuda', value: 'AG' },
  { name: 'Argentina', value: 'AR' },
  { name: 'Armenia', value: 'AM' },
  { name: 'Aruba', value: 'AW' },
  { name: 'Australia', value: 'AU' },
  { name: 'Austria', value: 'AT' },
  { name: 'Azerbaijan', value: 'AZ' },
  { name: 'Bahamas', value: 'BS' },
  { name: 'Bahrain', value: 'BH' },
  { name: 'Bangladesh', value: 'BD' },
  { name: 'Barbados', value: 'BB' },
  { name: 'Belarus', value: 'BY' },
  { name: 'Belgium', value: 'BE' },
  { name: 'Belize', value: 'BZ' },
  { name: 'Benin', value: 'BJ' },
  { name: 'Bermuda', value: 'BM' },
  { name: 'Bhutan', value: 'BT' },
  { name: 'Bolivia', value: 'BO' },
  { name: 'Bonaire, Sint Eustatius and Saba', value: 'BQ' },
  { name: 'Bosnia and Herzegovina', value: 'BA' },
  { name: 'Botswana', value: 'BW' },
  { name: 'Bouvet Island', value: 'BV' },
  { name: 'Brazil', value: 'BR' },
  { name: 'Brunei', value: 'BN' },
  { name: 'Bulgaria', value: 'BG' },
  { name: 'Burkina Faso', value: 'BF' },
  { name: 'Burundi', value: 'BI' },
  { name: 'Cape Verde', value: 'CV' },
  { name: 'Cambodia', value: 'KH' },
  { name: 'Cameroon', value: 'CM' },
  { name: 'Canada', value: 'CA' },
  { name: 'Cayman Islands', value: 'KY' },
  { name: 'Central African Republic', value: 'CF' },
  { name: 'Chad', value: 'TD' },
  { name: 'Chile', value: 'CL' },
  { name: 'China', value: 'CN' },
  { name: 'Christmas Island', value: 'CX' },
  { name: 'Cocos (Keeling) Islands', value: 'CC' },
  { name: 'Colombia', value: 'CO' },
  { name: 'Comoros', value: 'KM' },
  { name: 'Congo (Republic of the Congo)', value: 'CG' },
  { name: 'Congo', value: 'CD' },
  { name: 'Cook Islands', value: 'CK' },
  { name: 'Costa Rica', value: 'CR' },
  { name: 'Côte d', value: 'CI' },
  { name: 'Croatia', value: 'HR' },
  { name: 'Cuba', value: 'CU' },
  { name: 'Curaçao', value: 'CW' },
  { name: 'Cyprus', value: 'CY' },
  { name: 'Czech Republic', value: 'CZ' },
  { name: 'Denmark', value: 'DK' },
  { name: 'Djibouti', value: 'DJ' },
  { name: 'Dominica', value: 'DM' },
  { name: 'Dominican Republic', value: 'DO' },
  { name: 'Ecuador', value: 'EC' },
  { name: 'Egypt', value: 'EG' },
  { name: 'El Salvador', value: 'SV' },
  { name: 'Equatorial Guinea', value: 'GQ' },
  { name: 'Eritrea', value: 'ER' },
  { name: 'Estonia', value: 'EE' },
  { name: 'Eswatini', value: 'SZ' },
  { name: 'Ethiopia', value: 'ET' },
  { name: 'Falkland Islands (Malvinas)', value: 'FK' },
  { name: 'Faroe Islands', value: 'FO' },
  { name: 'Fiji Islands', value: 'FJ' },
  { name: 'Finland', value: 'FI' },
  { name: 'France', value: 'FR' },
  { name: 'French Guiana', value: 'GF' },
  { name: 'French Polynesia', value: 'PF' },
  { name: 'French Southern Territories', value: 'TF' },
  { name: 'Gabon', value: 'GA' },
  { name: 'Gambia', value: 'GM' },
  { name: 'Georgia', value: 'GE' },
  { name: 'Germany', value: 'DE' },
  { name: 'Ghana', value: 'GH' },
  { name: 'Gibraltar', value: 'GI' },
  { name: 'Greece', value: 'GR' },
  { name: 'Greenland', value: 'GL' },
  { name: 'Grenada', value: 'GD' },
  { name: 'Guadeloupe', value: 'GP' },
  { name: 'Guam', value: 'GU' },
  { name: 'Guatemala', value: 'GT' },
  { name: 'Guernsey', value: 'GG' },
  { name: 'Guinea', value: 'GN' },
  { name: 'Guinea-Bissau', value: 'GW' },
  { name: 'Guyana', value: 'GY' },
  { name: 'Haiti', value: 'HT' },
  { name: 'Honduras', value: 'HN' },
  { name: 'Hong Kong S.A.R', value: 'HK' },
  { name: 'Hungary', value: 'HU' },
  { name: 'Iceland', value: 'IS' },
  { name: 'India', value: 'IN' },
  { name: 'Indonesia', value: 'ID' },
  { name: 'Iran', value: 'IR' },
  { name: 'Iraq', value: 'IQ' },
  { name: 'Ireland', value: 'IE' },
  { name: 'Isle of Man', value: 'IM' },
  { name: 'Israel', value: 'IL' },
  { name: 'Italy', value: 'IT' },
  { name: 'Jamaica', value: 'JM' },
  { name: 'Japan', value: 'JP' },
  { name: 'Jersey', value: 'JE' },
  { name: 'Jordan', value: 'JO' },
  { name: 'Kazakhstan', value: 'KZ' },
  { name: 'Kenya', value: 'KE' },
  { name: 'Kiribati', value: 'KI' },
  { name: 'Kuwait', value: 'KW' },
  { name: 'Kyrgyzstan', value: 'KG' },
  { name: 'Laos', value: 'LA' },
  { name: 'Latvia', value: 'LV' },
  { name: 'Lebanon', value: 'LB' },
  { name: 'Lesotho', value: 'LS' },
  { name: 'Liberia', value: 'LR' },
  { name: 'Libya', value: 'LY' },
  { name: 'Liechtenstein', value: 'LI' },
  { name: 'Lithuania', value: 'LT' },
  { name: 'Luxembourg', value: 'LU' },
  { name: 'Macau S.A.R', value: 'MO' },
  { name: 'Madagascar', value: 'MG' },
  { name: 'Malawi', value: 'MW' },
  { name: 'Malaysia', value: 'MY' },
  { name: 'Maldives', value: 'MV' },
  { name: 'Mali', value: 'ML' },
  { name: 'Malta', value: 'MT' },
  { name: 'Marshall Islands', value: 'MH' },
  { name: 'Martinique', value: 'MQ' },
  { name: 'Mauritania', value: 'MR' },
  { name: 'Mauritius', value: 'MU' },
  { name: 'Mayotte', value: 'YT' },
  { name: 'Mexico', value: 'MX' },
  { name: 'Micronesia', value: 'FM' },
  { name: 'Moldova', value: 'MD' },
  { name: 'Monaco', value: 'MC' },
  { name: 'Mongolia', value: 'MN' },
  { name: 'Montenegro', value: 'ME' },
  { name: 'Montserrat', value: 'MS' },
  { name: 'Morocco', value: 'MA' },
  { name: 'Mozambique', value: 'MZ' },
  { name: 'Myanmar', value: 'MM' },
  { name: 'Namibia', value: 'NA' },
  { name: 'Nauru', value: 'NR' },
  { name: 'Nepal', value: 'NP' },
  { name: 'Netherlands (Holland)', value: 'NL' },
  { name: 'New Caledonia', value: 'NC' },
  { name: 'New Zealand', value: 'NZ' },
  { name: 'Nicaragua', value: 'NI' },
  { name: 'Niger', value: 'NE' },
  { name: 'Nigeria', value: 'NG' },
  { name: 'Niue', value: 'NU' },
  { name: 'Norfolk Island', value: 'NF' },
  { name: 'North Macedonia', value: 'MK' },
  { name: 'Northern Mariana Islands', value: 'MP' },
  { name: 'Norway', value: 'NO' },
  { name: 'Oman', value: 'OM' },
  { name: 'Pakistan', value: 'PK' },
  { name: 'Palau', value: 'PW' },
  { name: 'Palestine', value: 'PS' },
  { name: 'Panama', value: 'PA' },
  { name: 'Papua New Guinea', value: 'PG' },
  { name: 'Paraguay', value: 'PY' },
  { name: 'Peru', value: 'PE' },
  { name: 'Philippines', value: 'PH' },
  { name: 'Pitcairn Island', value: 'PN' },
  { name: 'Poland', value: 'PL' },
  { name: 'Portugal', value: 'PT' },
  { name: 'Puerto Rico', value: 'PR' },
  { name: 'Qatar', value: 'QA' },
  { name: 'Reunion', value: 'RE' },
  { name: 'Romania', value: 'RO' },
  { name: 'Russia', value: 'RU' },
  { name: 'Rwanda', value: 'RW' },
  { name: 'Saint Barthelemy', value: 'BL' },
  { name: 'Saint Helena, Ascension and Tristan da Cunha', value: 'SH' },
  { name: 'Saint Kitts and Nevis', value: 'KN' },
  { name: 'Saint Lucia', value: 'LC' },
  { name: 'Saint Martin', value: 'MF' },
  { name: 'Saint Pierre and Miquelon', value: 'PM' },
  { name: 'Saint Vincent and the Grenadines', value: 'VC' },
  { name: 'Samoa', value: 'WS' },
  { name: 'San Marino', value: 'SM' },
  { name: 'Sao Tome and Principe', value: 'ST' },
  { name: 'Saudi Arabia', value: 'SA' },
  { name: 'Senegal', value: 'SN' },
  { name: 'Serbia', value: 'RS' },
  { name: 'Seychelles', value: 'SC' },
  { name: 'Sierra Leone', value: 'SL' },
  { name: 'Singapore', value: 'SG' },
  { name: 'Slovakia', value: 'SK' },
  { name: 'Slovenia', value: 'SI' },
  { name: 'Solomon Islands', value: 'SB' },
  { name: 'Somalia', value: 'SO' },
  { name: 'South Africa', value: 'ZA' },
  { name: 'South Korea', value: 'KR' },
  { name: 'South Sudan', value: 'SS' },
  { name: 'Spain', value: 'ES' },
  { name: 'Sri Lanka', value: 'LK' },
  { name: 'Sudan', value: 'SD' },
  { name: 'Suriname', value: 'SR' },
  { name: 'Svalbard and Jan Mayen', value: 'SJ' },
  { name: 'Sweden', value: 'SE' },
  { name: 'Switzerland', value: 'CH' },
  { name: 'Taiwan', value: 'TW' },
  { name: 'Tajikistan', value: 'TJ' },
  { name: 'Tanzania', value: 'TZ' },
  { name: 'Thailand', value: 'TH' },
  { name: 'Timor-Leste', value: 'TL' },
  { name: 'Togo', value: 'TG' },
  { name: 'Tokelau', value: 'TK' },
  { name: 'Tonga', value: 'TO' },
  { name: 'Trinidad and Tobago', value: 'TT' },
  { name: 'Tunisia', value: 'TN' },
  { name: 'Turkey', value: 'TR' },
  { name: 'Turkmenistan', value: 'TM' },
  { name: 'Turks and Caicos Islands', value: 'TC' },
  { name: 'Tuvalu', value: 'TV' },
  { name: 'Uganda', value: 'UG' },
  { name: 'Ukraine', value: 'UA' },
  { name: 'United Arab Emirates', value: 'AE' },
  { name: 'United Kingdom', value: 'GB' },
  { name: 'United States of America', value: 'US' },
  { name: 'Uruguay', value: 'UY' },
  { name: 'Uzbekistan', value: 'UZ' },
  { name: 'Vanuatu', value: 'VU' },
  { name: 'Venezuela', value: 'VE' },
  { name: 'Vatican City State', value: 'VA' },
  { name: 'Vietnam', value: 'VN' },
  { name: 'Virgin Islands (British)', value: 'VG' },
  { name: 'Virgin Islands (U.S.)', value: 'VI' },
  { name: 'Wallis and Futuna Islands', value: 'WF' },
  { name: 'Western Sahara', value: 'EH' },
  { name: 'Yemen', value: 'YE' },
  { name: 'Zambia', value: 'ZM' },
  { name: 'Zimbabwe', value: 'ZW' },
] as const;

export const TRANSFERMATE_STATE_COUNTRIES = ['CA', 'US', 'AU'] as const;

export const TRANSFERMATE_RELATIONSHIPS = {
  parent: [
    { value: 'father', label: 'Father' },
    { value: 'mother', label: 'Mother' },
  ],
  family: [
    { value: 'brother', label: 'Brother' },
    { value: 'sister', label: 'Sister' },
    { value: 'son', label: 'Son' },
    { value: 'daughter', label: 'Daughter' },
    { value: 'grandparent', label: 'Grandparent' },
    { value: 'other', label: 'Other' },
  ],
  other: [
    { value: 'husband/wife', label: 'Husband/Wife' },
    { value: 'noFamilyRelationship', label: 'No Family Relationship' },
    { value: 'friend/colleague', label: 'Friend/Colleague' },
    { value: 'educationalConsultant/agent', label: 'Educational Consultant/Agent' },
    { value: 'visitingAcademic', label: 'Visiting Academic' },
  ],
} as const;

export const TRANSFERMATE_FX_DEBOUNCE_MS = 600;

export const TRANSFERMATE_SOURCE_OF_FUNDS = [
  { value: 'resident_savings', label: 'Resident Savings' },
  { value: 'education_loan', label: 'Education Loan' },
] as const;

export const TRANSFERMATE_PAN_PATTERN = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
export const TRANSFERMATE_CHINESE_NAME_PATTERN = /^[\u4e00-\u9fa5]{1,50}$/;
export const TRANSFERMATE_EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export interface TransferMateDocumentDefinition {
  readonly labelKey: string;
  readonly helperKey: string;
  readonly pattern: RegExp;
}

export const TRANSFERMATE_STUDENT_DOCUMENTS: Readonly<
  Record<string, TransferMateDocumentDefinition>
> = {
  BR: {
    labelKey: 'payment.transfermate.documentLabel.cpf',
    helperKey: 'payment.transfermate.documentHelper.cpf',
    pattern: /^\d{3}\.\d{3}\.\d{3}-\d{2}$/,
  },
  CN: {
    labelKey: 'payment.transfermate.documentLabel.citizenIdNumber',
    helperKey: 'payment.transfermate.documentHelper.eighteenDigits',
    pattern: /^[1-9]\d{5}(19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
  },
};

export const TRANSFERMATE_PAYER_DOCUMENTS: Readonly<
  Record<string, TransferMateDocumentDefinition>
> = {
  AR: {
    labelKey: 'payment.transfermate.documentLabel.dniOrCuit',
    helperKey: 'payment.transfermate.documentHelper.sevenNineOrElevenDigits',
    pattern: /^(?:\d{7,9}|\d{11})$/,
  },
  BO: {
    labelKey: 'payment.transfermate.documentLabel.ci',
    helperKey: 'payment.transfermate.documentHelper.fiveToTwentyDigits',
    pattern: /^\d{5,20}$/,
  },
  BR: {
    labelKey: 'payment.transfermate.documentLabel.cpf',
    helperKey: 'payment.transfermate.documentHelper.cpf',
    pattern: /^\d{3}\.\d{3}\.\d{3}-\d{2}$/,
  },
  CL: {
    labelKey: 'payment.transfermate.documentLabel.ciRut',
    helperKey: 'payment.transfermate.documentHelper.eightOrNineDigits',
    pattern: /^.{8,9}$/,
  },
  CN: {
    labelKey: 'payment.transfermate.documentLabel.citizenIdNumber',
    helperKey: 'payment.transfermate.documentHelper.eighteenDigits',
    pattern: /^[1-9]\d{5}(19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
  },
  CO: {
    labelKey: 'payment.transfermate.documentLabel.cc',
    helperKey: 'payment.transfermate.documentHelper.sixToTenDigits',
    pattern: /^\d{6,10}$/,
  },
  EC: {
    labelKey: 'payment.transfermate.documentLabel.ci',
    helperKey: 'payment.transfermate.documentHelper.fiveToTwentyDigits',
    pattern: /^\d{5,20}$/,
  },
  EG: {
    labelKey: 'payment.transfermate.documentLabel.id',
    helperKey: 'payment.transfermate.documentHelper.fourteenDigits',
    pattern: /^\d{14}$/,
  },
  ID: {
    labelKey: 'payment.transfermate.documentLabel.nik',
    helperKey: 'payment.transfermate.documentHelper.sixteenDigits',
    pattern: /^\d{16}$/,
  },
  IN: {
    labelKey: 'payment.transfermate.documentLabel.payerPan',
    helperKey: 'payment.transfermate.documentHelper.pan',
    pattern: TRANSFERMATE_PAN_PATTERN,
  },
  MX: {
    labelKey: 'payment.transfermate.documentLabel.curp',
    helperKey: 'payment.transfermate.documentHelper.tenToEighteenDigits',
    pattern: /^.{10,18}$/,
  },
  MA: {
    labelKey: 'payment.transfermate.documentLabel.cnie',
    helperKey: 'payment.transfermate.documentHelper.fiveToTwentyDigits',
    pattern: /^.{5,20}$/,
  },
  NG: {
    labelKey: 'payment.transfermate.documentLabel.nin',
    helperKey: 'payment.transfermate.documentHelper.elevenDigits',
    pattern: /^\d{11}$/,
  },
  PY: {
    labelKey: 'payment.transfermate.documentLabel.ci',
    helperKey: 'payment.transfermate.documentHelper.fiveToTwentyDigits',
    pattern: /^\d{5,20}$/,
  },
  PE: {
    labelKey: 'payment.transfermate.documentLabel.dni',
    helperKey: 'payment.transfermate.documentHelper.eightOrNineDigits',
    pattern: /^\d{8,9}$/,
  },
  ZA: {
    labelKey: 'payment.transfermate.documentLabel.id',
    helperKey: 'payment.transfermate.documentHelper.fiveToTwentyDigits',
    pattern: /^\d{5,20}$/,
  },
  TR: {
    labelKey: 'payment.transfermate.documentLabel.tcKimlikNo',
    helperKey: 'payment.transfermate.documentHelper.fiveToTwentyDigits',
    pattern: /^\d{5,20}$/,
  },
  US: {
    labelKey: 'payment.transfermate.documentLabel.ssn',
    helperKey: 'payment.transfermate.documentHelper.ssn',
    pattern: /^(?!000|666)[0-8]\d{2}-(?!00)\d{2}-(?!0000)\d{4}$/,
  },
  UY: {
    labelKey: 'payment.transfermate.documentLabel.ci',
    helperKey: 'payment.transfermate.documentHelper.sixToEightDigits',
    pattern: /^\d{6,8}$/,
  },
};

export const TRANSFERMATE_PAYMENT_METHOD_NAMES: Readonly<Record<number, string>> = {
  1: 'VISA Credit',
  2: 'VISA Debit',
  3: 'Mastercard Credit',
  4: 'Mastercard Debit',
  5: 'AMEX',
  6: 'Maestro',
  7: 'Discover Card',
  8: 'UnionPay',
  9: 'JCB',
};

export const TRANSFERMATE_MESSAGE = {
  COUNTRY_REQUIRED: 'Country is required',
  SOURCE_OF_FUNDS_REQUIRED: 'Source of fund is required',
  DECLARATION_AMOUNT_REQUIRED: 'Enter a valid declaration amount',
  PAN_REQUIRED: 'Enter a valid 10-character payer PAN',
  FEE_EXCEED_REQUIRED: 'This field is required',
  NO_PAYMENT_METHODS: 'Card is not supported for the selected country.',
  FX_ERROR: 'Unable to load payment options. Please try again.',
} as const;
